import { BaseObjectEntity } from '@/types';
import { path } from '@/utils/formatLink';
import { generatePath } from 'react-router';

export const ROOTS_IN_APP_POPUPS = '/in-app-popups';

export const PATH_IN_APP_POPUPS: BaseObjectEntity = {
  root: ROOTS_IN_APP_POPUPS,
  list: '',
  new: '/new',
  edit: '/:popupId/edit',
};

export function inAppPopupsPath(pathKey: string, params?: BaseObjectEntity) {
  return generatePath(
    path(ROOTS_IN_APP_POPUPS, PATH_IN_APP_POPUPS[pathKey]),
    params
  );
}
